import { Routes } from '@angular/router';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { MainPageComponent } from './layout/main-page/main-page.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import { ShipmentsComponent } from './pages/shipments/shipments.component';
import { ContainersComponent } from './pages/containers/containers.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { HowToComponent } from './pages/how-to/how-to.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ArchiveComponent } from './pages/archive/archive.component';
import { requireModulesActivate } from './guards/route.guard';
import { requirePageAccess } from './guards/page-access.guard';
import { VesselSchedulesComponent } from './pages/vessel-schedules/vessel-schedules.component';
import { LoginFailedComponent } from './pages/login-failed/login-failed.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { OrderExceptionsComponent } from './pages/order-exceptions/order-exceptions.component';
import { UsersComponent } from './pages/admin/components/users/users.component';
import { ContactsComponent } from './pages/admin/components/contacts/contacts.component';
import { OrganisationsComponent } from './pages/admin/components/organisations/organisations.component';
import { AlertsComponent } from './pages/admin/components/alerts/alerts.component';
import { confirmUnsavedChanges } from './guards/confirm-unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    component: MainPageComponent,
    canActivate: [MsalGuard, requirePageAccess()],
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadChildren: () => import('./pages/overview/overview.routes').then(m => m.overviewRoutes)
      },
      {
        path: 'shipments',
        component: ShipmentsComponent,
        canActivate: [requireModulesActivate(['Shipments'])],
        children: [{ path: ':id', component: ShipmentsComponent }]
      },
      {
        path: 'containers',
        component: ContainersComponent,
        canActivate: [requireModulesActivate(['Containers'])],
        children: [{ path: ':id', component: ContainersComponent }]
      },
      {
        path: 'orders',
        component: OrdersComponent,
        canActivate: [requireModulesActivate(['Orders'])],
        children: [{ path: ':id', component: OrdersComponent }]
      },
      {
        path: 'order-exceptions',
        component: OrderExceptionsComponent,
        canActivate: [requireModulesActivate(['OrderExceptions'])],
        children: [{ path: ':id', component: OrderExceptionsComponent }]
      },
      { path: 'documents', component: DocumentsComponent, canActivate: [requireModulesActivate(['Documents'])] },
      { path: 'archive', component: ArchiveComponent, canActivate: [requireModulesActivate(['Archive'])] },
      { path: 'how-to', component: HowToComponent, canActivate: [requireModulesActivate(['Tutorials'])] },
      // { path: 'logs', redirectTo: 'overview', pathMatch: 'full' },
      // {
      //   path: 'vessel-schedules',
      //   component: VesselSchedulesComponent,
      //   canActivate: [requireModulesActivate(['VesselSchedules'])]
      // },
      { path: 'contact', component: ContactComponent, canActivate: [requireModulesActivate(['Contact'])] },
      {
        path: 'admin',
        canActivate: [requireModulesActivate(['Admin'])],
        children: [
          { path: '', redirectTo: 'users', pathMatch: 'full' },
          { path: 'users', component: UsersComponent },
          { path: 'contacts', component: ContactsComponent },
          {
            path: 'organisations',
            component: OrganisationsComponent,
            canDeactivate: [confirmUnsavedChanges]
          },
          {
            path: 'organisations-v2',
            loadChildren: () =>
              import('./pages/admin/components/organisation-admin/organisation-admin.routes').then(
                m => m.ORGANISATION_ADMIN_ROUTES
              )
          },
          { path: 'alerts', component: AlertsComponent }
        ]
      }
    ]
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'not-found', component: NotFoundComponent, canActivate: [MsalGuard] },
  { path: 'login-failed', component: LoginFailedComponent },
  { path: '**', redirectTo: 'not-found', pathMatch: 'full' }
];
